import {HomePinnedCardResource} from 'common/report/model-resources/home-pinned-card-controller';
import {contextify} from 'common/util/react';

const context = contextify<HomePinnedCardResource>();

export const HomePinnedCardProvider = context.Provider;
export const HomePinnedCardConsumer = context.Consumer;
export const useHomePinnedCard = context.hook;
